
  var _styles = {
  "list-container": {
    "width": "100%"
  },
  "list-container--invalid": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%"
  },
  "list-container--loading": {
    "backgroundColor": "rgb(255,255,0)"
  },
  "list-container--success-vertical": {
    "display": "flex",
    "flexDirection": "column",
    "flexWrap": "wrap",
    "justifyContent": "flex-start",
    "alignItems": "center"
  },
  "list-container--success-horizontal": {
    "paddingLeft": "0.21333rem"
  },
  "list-container--success-horizontal-scroll": {
    "paddingTop": "0.08rem",
    "paddingRight": 0,
    "paddingBottom": "0.08rem",
    "paddingLeft": 0
  },
  "list-container__item--vertical": {
    "marginBottom": "0.21333rem"
  },
  "list-container__item--horizontal": {
    "marginRight": "0.21333rem"
  }
};



  module.exports = _styles;
  